export const PARTNER_CONSTS = {
    GET_PARTNERS: "GET_PARTNERS",
    CREATE_PARTNER: "CREATE_PARTNER",
    UPDATE_PARTNERS_POSITIONS: "UPDATE_PARTNERS_POSITIONS",
    UPDATE_PARTNER_BY_ID: "UPDATE_PARTNER_BY_ID",
    DELETE_PARTNER_BY_ID: "DELETE_PARTNER_BY_ID",
    GET_PARTNER_REQUESTS: "GET_PARTNER_REQUESTS",
    DELETE_PARTNER_REQUEST_BY_ID: "DELETE_PARTNER_REQUEST_BY_ID",
};
